import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable, runInAction, intercept } from 'mobx'
import styled, { keyframes } from 'styled-components'
import { TweenMax } from 'gsap'
import UpArrowIcon from '@/assets/images/preplay-up-arrow-black.webp'
import LockIcon from '@/assets/images/icon-lock-black.svg'
import DragNDropIcon from '@/assets/images/dragndrop-dots.png'
import PendingIndicatorIcon from '@/assets/images/pending-indicator.svg'
import { Draggable } from 'react-beautiful-dnd'
import DDSponsorBrand from '@/Components/CommandHost/Common/DDSponsorBrand'
import DDStar from '@/Components/CommandHost/Common/DDStar'
import DDAwards from '@/Components/CommandHost/Common/DDAwards'
import DDTeam from '@/Components/CommandHost/Common/DDTeam'
import TeamItem from '@/Components/CommandHost/Common/TeamItem'
import { vhToPx } from '@/utils'
import {
  OptionInputsWrapper,
  DDSelectType,
  StarWrapper,
  PlayOrTimerWrapper,
  AwardWrapper,
} from './style'
import DDAnnounceSponsor from '@/Components/CommandHost/Common/DDAnnounceSponsor'
import _ from 'lodash'
import { responsiveDimension } from '../../utils'

const PlayColors = {
  liveplay: '#c61818',
  gamemaster: '#19d1bf',
  sponsor: '#495bdb',
  prize: '#9368aa',
}

@inject(
  'PrePlayStore',
  'PlayStore',
  'GameStore',
  'CommandHostStore',
  'AutomationStore',
  'CommonStore'
)
@observer
export default class PlayItemOnStack extends Component {
  constructor(props) {
    super(props)
    FONT_SIZE = this.props.CommandHostStore.fontSize + 'vh'
    extendObservable(this, {
      promptRemove: false,
      multiplier: 1,
      optionCount: 1,
      presetItems: null,
      preItem: null,
      values: {
        index: 0,
        type: '',
        playTitle: '',
        choices: [],
        stars: 0,
        points: 0,
        tokens: 0,
        currencyFixed: '',
        length: 0,
      },
      hasChanges: false,
      initialItemchoices: null,
      sourcePlayData: _.cloneDeep(this.props.item),
    })

    this.has_mult =
      this.props.item.type.toLowerCase().indexOf('liveplay') === 0 ||
      this.props.item.type.toLowerCase().indexOf('gamemaster') === 0

    this.sourceQuestionInput =
      this.props.item.playTitle && this.props.item.playTitle.value
        ? this.props.item.playTitle.value
        : ''
    this.sourceChoices =
      this.props.item && this.props.item.choices
        ? this.props.item.choices.map((item, index) => {
            return item.value
          })
        : ''
    this.questionInputId = `questioninput-${this.props.item.id}`

    this.MAIN_CHOICE = this.props.item.multiplierChoices.filter(
      o => o.id == this.props.item.id
    )[0]

    this._isMounted = false

    //AUTOMATION
    if (
      this.props.GameStore.executionType === 'recording' &&
      this.props.PrePlayStore.sessionButtons['start'] &&
      (
        this.props.PrePlayStore.sessionButtons['start'].text || ''
      ).toLowerCase() === 'resume session'
    ) {
      this.state = {
        sessionStarted: false,
        announcementHasChanges: false,
        isPmetadataUpdated: false,
        isOpinionQuestion: false,
        isSelectionModeChanged: false,
      }
    } else {
      this.state = {
        sessionStarted: this.props.GameStore.isSessionStarted,
        announcementHasChanges: false,
        isPmetadataUpdated: false,
        isOpinionQuestion: false,
        isSelectionModeChanged: false,
      }
    }

    this.destroyProgress = intercept(
      this.props.GameStore,
      'progress',
      change => {
        this.setState({ sessionStarted: change.newValue === 'live' })
        return change
      }
    )

    this.destroySessionMode = intercept(
      this.props.GameStore,
      'sessionMode',
      change => {
        this.setState({ sessionStarted: change.newValue === 1 })
        return change
      }
    )

    this.disposeSelectionMode = intercept(
      this.props.CommonStore,
      'selectionMode',
      change => {
        if (change && change.newValue) {
          this.setState({ isSelectionModeChanged: change.newValue })
        }
      }
    )
  }

  handleDDOptionChange() {
    const ddoption = document.getElementById(
      `dd-option-playitemonstack-${this.props.item.index}`
    )

    if (ddoption) {
      this.preItem = this.presetItems.filter(
        o => o.id === parseInt(ddoption.value)
      )[0]
      if (this.preItem) {
        this.props.item.preset = this.preItem
        this.props.item.playTitle.id = this.preItem.id
        this.props.item.playTitle.value = this.preItem.question
        this.optionCount = (this.preItem.choices || []).length

        this.props.PrePlayStore.pullMultiplierChoices(
          parseInt(ddoption.value)
        ).then(data => {
          this.props.item.multiplierChoices = data
        })

        this.resetChoiceInputs()
        if (this._isMounted) {
          this.forceUpdate()
        }
        //this.props.gamesUpdatePreset({playId: this.props.item.id, predeterminedName: this.preItem.preset})
      }
    }
  }

  handleDDTimerModeChange(e) {
    this.props.item.length = parseInt(e.target.value)
    if (this._isMounted) {
      this.forceUpdate()
    }
  }

  handleQuestionChange(refId, e) {
    const el = document.getElementById(refId)
    if (el) {
      if (
        e.target.value.toLowerCase() == this.sourceQuestionInput.toLowerCase()
      ) {
        el.style.border = `none`
        this.isQuestionChanged = false
      } else {
        el.style.border = `${0.2}vh solid #ff0000`
        this.isQuestionChanged = true
      }
    }

    this.playTitle = e.target.value
    this.props.item.playTitle.value = this.playTitle
    this.hasChanges = this.isQuestionChanged || this.areChociesChanged
    this.props.PrePlayStore.setLiveEditingItems(this.props.item)
    if (this._isMounted) {
      this.forceUpdate()
    }
  }

  handleMultOrFixed(currency, value) {
    if (!this.has_mult) {
      this.values.currencyFixed = ''
      return
    }

    const _letter = currency.substring(0, 1).toLowerCase()
    let _changed = false
    let _currency_fixed = this.values.currencyFixed
    if (
      (!this.values.currencyFixed ||
        this.values.currencyFixed.indexOf(_letter) === -1) &&
      value
    ) {
      _currency_fixed += _letter
      _changed = true
    } else if (
      this.values.currencyFixed &&
      this.values.currencyFixed.indexOf(_letter) !== -1 &&
      !value
    ) {
      _currency_fixed = _currency_fixed.replace(_letter, '')
      _changed = true
    }
    if (_changed) {
      this.props.item.currencyFixed = _currency_fixed
      //this.props.gamesUpdate(this.props.item)
      this.handleUpdateChanges(true)
    }
  }

  handleStarValue(val, mult_or_fixed_currency, mult_or_fixed_value) {
    if (mult_or_fixed_currency) {
      this.handleMultOrFixed(mult_or_fixed_currency, mult_or_fixed_value)
      return
    }
    this.props.item.stars = val
    //this.props.gamesUpdate(this.props.item)
    this.handleUpdateChanges(true)
  }

  handleAutomationAddEvent(params) {
    this.props.AutomationStore.addEvent(params)
  }

  handleSponsorBrandValue(val) {
    this.props.item.sponsor = val
    this.props.gamesUpdate(this.props.item)
  }

  handleTeamValue(val) {
    this.props.item.team = val
    this.props.gamesUpdate(this.props.item)
  }

  handleAwardValue(
    val,
    mult_or_fixed_currency,
    mult_or_fixed_value,
    specialFeature = null
  ) {
    if (specialFeature && this.props.item) {
      let pmetadata = this.props.item.pmetadata || {}
      pmetadata.public = pmetadata.public || {}
      pmetadata.public[specialFeature.name] = specialFeature.value
      this.props.item.pmetadata = pmetadata
      this.values.pmetadata = pmetadata
    } else {
      if (mult_or_fixed_currency) {
        this.handleMultOrFixed(mult_or_fixed_currency, mult_or_fixed_value)
        return
      }
      ;['tokens', 'points'].forEach(currency => {
        if (val.hasOwnProperty(currency)) {
          this.values[currency] = val[currency]
          this.props.item[currency] = val[currency]
        }
      })
    }
    //this.props.gamesUpdate(this.props.item)
    this.handleUpdateChanges(true)
  }

  handleTimerChange(updatedItem) {
    if (
      this.sourcePlayData &&
      this.sourcePlayData.pmetadata &&
      updatedItem &&
      updatedItem.pmetadata &&
      this.sourcePlayData.pmetadata.timerInput !==
        updatedItem.pmetadata.timerInput
    ) {
      this.hasChanges = true
      this.setState({ isPmetadataUpdated: true })
      this.updatedItem = { ...this.props.item, ...updatedItem }
      this.props.item.pmetadata = updatedItem.pmetadata
    } else if (this.sourcePlayData && !this.sourcePlayData.pmetadata) {
      this.hasChanges = true
      this.setState({ isPmetadataUpdated: true })
      this.updatedItem = { ...this.props.item, ...updatedItem }
      this.props.item.pmetadata = updatedItem.pmetadata
    } else {
      this.setState({ isPmetadataUpdated: false })
      this.hasChanges = false
    }
  }

  handleChoiceChange(i, e) {
    this.MAIN_CHOICE.choices[i].value = e.target.value
    this.props.item.choices = this.MAIN_CHOICE.choices
    if (this.areChoicesEqual(this.MAIN_CHOICE.choices)) {
      this.areChociesChanged = false
    } else {
      this.areChociesChanged = true
    }

    this.hasChanges = this.isQuestionChanged || this.areChociesChanged
    this.props.PrePlayStore.setLiveEditingItems(this.props.item)
    if (this._isMounted) {
      this.forceUpdate()
    }
  }

  areChoicesEqual = choices => {
    if (choices.length !== this.sourceChoices.length) {
      return false
    }

    return choices.every(
      (choice, i) =>
        choice.value.toLowerCase() === this.sourceChoices[i].toLowerCase()
    )
  }

  resetChoiceInputs() {
    this.props.item.choices = []
    for (let i = 0; i < (this.preItem.choices || []).length; i++) {
      let inputVal = this.preItem.choices[i]
      this.props.item.choices.push(inputVal)
    }
  }

  handleRemoveClick(refId) {
    //this.props.AutomationStore.addEvent({evt:'click', refId: refId, wait: 2, playId: this.props.item.id})
    this.promptRemove = true
    this.forceUpdate()
    setTimeout(() => {
      this.promptRemove = false
      if (this._isMounted) {
        this.forceUpdate()
      }
    }, 3000)
  }

  handlePromptRemoveClick(refId) {
    //this.props.AutomationStore.addEvent({evt:'click', refId: refId, wait: 1, playId: this.props.item.id})

    this.props.item.executionType = (
      this.props.GameStore.executionType || ''
    ).toLowerCase()
    this.props.remove(this.props.item)
  }

  handlePromptRemoveClickX1() {
    const itemToRemove = this.props.PrePlayStore.preplayItems.filter(
      o => o.index === this.props.item.index
    )[0]
    if (itemToRemove) {
      const idx = this.props.PrePlayStore.preplayItems.indexOf(itemToRemove)
      this.props.remove(idx)
    }
  }

  handleGoClick(itemId, refId) {
    this.props.AutomationStore.addEvent({
      evt: 'click',
      refId: refId,
      wait: this.props.AutomationStore.currentTime,
      playId: itemId,
    })

    if (this[`stack-play-go-${itemId}`]) {
      TweenMax.set(this[`stack-play-go-${itemId}`], { display: 'none' })
      TweenMax.set(this[`stack-play-indicator-go-${itemId}`], {
        display: 'flex',
      })
    }

    this.props.go(this.props.item)
  }

  handleGoClickX1() {
    const itemToNextPlay = this.props.PrePlayStore.preplayItems.filter(
      o => o.index === this.props.item.index
    )[0]
    if (itemToNextPlay) {
      const idxTo = this.props.PrePlayStore.preplayItems.length - 1
      const idxFrom = this.props.PrePlayStore.preplayItems.indexOf(
        itemToNextPlay
      )
      this.props.go(idxFrom, idxTo, itemToNextPlay)
    }
  }

  OptionInputs() {
    let comp = []
    let reference = `playitemonstack-choice-${this.props.item.index}-`

    if (!this.preItem) return null
    if (this.MAIN_CHOICE && this.MAIN_CHOICE.choices) {
      if (this.MAIN_CHOICE.readOnly && !this.MAIN_CHOICE.choices.length) {
        this.MAIN_CHOICE.choices.push({ value: '{player1}' })
        this.MAIN_CHOICE.choices.push({ value: '{player2}' })
      }
      const choices = this.MAIN_CHOICE.choices.sort(
        (a, b) => a.sequence - b.sequence
      )
      for (let i = 0; i < choices.length; i++) {
        const mulChoice = choices[i]
        let propsItemChoice = this.props.item.choices.filter(o => {
          const _ov = (o.value || '').toLowerCase()
          if (_ov === (mulChoice.value || '').toLowerCase()) return true
          if (!mulChoice) return false
          const _mulChoice = this.preprocessPresetChoice(
            mulChoice.value,
            null,
            null,
            true
          )
          return _ov === (_mulChoice ? _mulChoice.toLowerCase() : '')
        })[0]
        if (
          this.props.liveEditingItem ||
          (propsItemChoice &&
            propsItemChoice.value &&
            choices[i].value &&
            propsItemChoice.value.toLowerCase() !==
              choices[i].value.toLowerCase() &&
            this.preprocessPresetChoice(choices[i].value, null, null, true))
        )
          propsItemChoice = choices[i]

        if (propsItemChoice) {
          let _comp_from_tpl = propsItemChoice.value
            ? this.preprocessPresetChoice(propsItemChoice.value, reference, i)
            : null
          if (_comp_from_tpl) {
            comp.push(_comp_from_tpl)
          } else {
            comp.push(
              <OptionInputDiv
                key={reference + i}
                marginRight={
                  this.MAIN_CHOICE &&
                  i < (this.MAIN_CHOICE.choices || []).length - 1
                }
              >
                <OptionInput
                  disabled={
                    (this.props.item.multiplierChoices || []).length > 1
                      ? true
                      : false
                  }
                  readOnly={this.preItem.readOnly}
                  color={'#ffffff'}
                  backgroundColor={
                    PlayColors[this.props.item.type.toLowerCase()]
                  }
                  value={propsItemChoice.value || choices[i].value}
                  onChange={this.handleChoiceChange.bind(this, i)}
                />
              </OptionInputDiv>
            )
          }
        }
      }
    }
    return comp
  }

  preprocessPresetChoice(choice, reference, i, return_match) {
    const field = choice.match(/^\{(\w+)\}$/)
    if (field) {
      const field_match = field[1].match(/^player(\d+)$/i)
      if (field_match) {
        if (return_match)
          return this.props.PrePlayStore.teams.length >= field_match[1]
            ? this.props.PrePlayStore.teams[field_match[1] - 1].teamName
            : null
        return this.preprocessPresetChoicePlayer(field_match[1], reference, i)
      }
    }
    for (let _i = 0; _i < this.props.PrePlayStore.teams.length; ++_i) {
      if (this.props.PrePlayStore.teams[_i].teamName === choice)
        return return_match
          ? choice
          : this.preprocessPresetChoicePlayer(_i + 1, reference, i)
    }
    return null
  }

  preprocessPresetChoicePlayer(player_number, reference, i) {
    const t = this.props.PrePlayStore.teams[player_number - 1]
    runInAction(() => {
      if (this.props.item.choices[i] && t) {
        this.props.item.choices[i].id = t.id
        this.props.item.choices[i].value = t.teamName
      }
    })
    return (
      <TeamItemWrapper
        key={reference + i}
        marginRight={
          i <
          (this.MAIN_CHOICE ? (this.MAIN_CHOICE.choices || []).length - 1 : -1)
        }
      >
        <TeamItem
          team={t}
          backgroundColor={PlayColors[this.props.item.type.toLowerCase()]}
        />
      </TeamItemWrapper>
    )
  }

  updatePresetItemsToCustom(callback) {
    let presetToUpdate = this.presetItems.filter(
      o => o.id === this.props.item.playTitle.id
    )[0]
    if (presetToUpdate) {
      presetToUpdate.choices = []
      presetToUpdate.question = this.props.item.playTitle.value
      for (let i = 0; i < (this.props.item.choices || []).length; i++) {
        presetToUpdate.choices.push(this.props.item.choices[i])
      }

      callback(presetToUpdate)
    }
  }

  handleUpdateChanges(force) {
    if (
      force ||
      (this.props.item.multiplierChoices &&
        this.props.item.multiplierChoices.length > 0)
    ) {
      if (
        this.props.item.multiplierChoices &&
        this.props.item.multiplierChoices.length > 0
      ) {
        let _choice = this.props.item.multiplierChoices.filter(
          _ch => _ch.id === this.props.item.id
        )[0]
        if (
          _choice &&
          this.props.item.playTitle &&
          this.props.item.playTitle.value
        ) {
          _choice.question = this.props.item.playTitle.value.toLowerCase()
        }
        if (_choice) {
          _choice.choices = this.props.item.choices
        }
      }
      this.props.gamesUpdate(
        this.state.isPmetadataUpdated ? this.updatedItem : this.props.item
      )
      this.props.PrePlayStore.setLiveEditingItems(this.props.item, true)
    }

    const el = document.getElementById(this.questionInputId)
    if (el) {
      el.style.border = 'none'
    }
    this.sourceChoices =
      this.props.item && this.props.item.choices
        ? this.props.item.choices.map((item, index) => {
            return item.value
          })
        : ''
    this.sourceQuestionInput =
      this.props.item.playTitle && this.props.item.playTitle.value
        ? this.props.item.playTitle.value
        : ''
    this.hasChanges = false
    this.setState({ announcementHasChanges: false })
    this.forceUpdate()
  }

  componentWillMount() {
    this.presetItems = JSON.parse(
      JSON.stringify(
        this.props.PrePlayStore.getPresetItemsByType(this.props.item.type)
      )
    )

    this.values = this.props.item
    this.preItem = this.props.item.preset

    /*
    this.presetItems = JSON.parse(
      JSON.stringify(
        this.props.PrePlayStore.getPresetItemsByType(this.props.item.type)
      )
    )
    //this.values = this.props.item
    // this.updatePresetItemsToCustom(defaultPreset => {
    //   if (defaultPreset) {
    //     this.props.item.preset = this.props.item.preset || defaultPreset
    //     this.values = this.props.item
    //     this.preItem = defaultPreset
    //   } else {
    //     this.props.item.preset = this.presetItems[0]
    //     this.values = this.props.item
    //     this.preItem = this.presetItems[0]
    //   }
    //
    //   this.resetChoiceInputs()
    // })
    const multiChoices = this.props.PlayStore.multipliersFromStackByPlayId(
      this.props.item
    )
    if (multiChoices && multiChoices.length > 0) {
      const idxToUpdate = this.presetItems.findIndex(
        o => o.preset === multiChoices[0].preset
      )
      if (idxToUpdate > -1) {
        this.presetItems[idxToUpdate] = multiChoices[0]
        this.props.item.preset = this.presetItems[idxToUpdate]
        this.values = this.props.item
        this.preItem = this.presetItems[idxToUpdate]
      } else {
        this.props.item.preset = this.presetItems[0]
        this.values = this.props.item
        this.preItem = this.presetItems[0]
      }
    } else {
      this.props.item.preset = this.presetItems[0]
      this.values = this.props.item
      this.preItem = this.presetItems[0]
    }
    this.resetChoiceInputs()
*/
  }

  componentWillUnmount() {
    this._isMounted = false
    this.destroyProgress()
    this.destroySessionMode()
    this.disposeSelectionMode()
  }

  componentDidMount() {
    this._isMounted = true
    this.playTitle = this.props.liveEditingItem
      ? this.props.liveEditingItem.playTitle.value
      : this.props.item.playTitle.value
    delete this.props.item.editorEvents
    delete this.props.item.recordedAutomation
    if (
      this.props.item &&
      this.props.item.pmetadata &&
      this.props.item.pmetadata.public
    ) {
      const publicData = this.props.item.pmetadata.public
      this.setState({
        isOpinionQuestion: publicData.opinionQuestion,
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.item !== this.props.item) {
      this.values = nextProps.item
      this.preItem = nextProps.item.preset
      if (nextProps.item.multiplierChoices) {
        this.MAIN_CHOICE = nextProps.item.multiplierChoices.filter(
          o => o.id == nextProps.item.id
        )[0]
      }
      this.playTitle = nextProps.liveEditingItem
        ? nextProps.liveEditingItem.playTitle.value
        : nextProps.item.playTitle.value

      this.sourceQuestionInput =
        nextProps.item.playTitle && nextProps.item.playTitle.value
          ? nextProps.item.playTitle.value
          : ''
      this.sourceChoices =
        nextProps.item && nextProps.item.choices
          ? nextProps.item.choices.map((item, index) => {
              return item.value
            })
          : ''

      if (
        nextProps.item &&
        nextProps.item.pmetadata &&
        nextProps.item.pmetadata.public
      ) {
        const publicData = nextProps.item.pmetadata.public
        this.setState({
          isOpinionQuestion: publicData.opinionQuestion,
        })
      }
    }
  }

  handleSelectedSponsor(val, isAutomatic) {
    if (!this.props.item.pmetadata) this.props.item.pmetadata = {}
    if (typeof this.props.item.pmetadata === 'string') {
      try {
        this.props.item.pmetadata = JSON.parse(this.props.item.pmetadata)
      } catch (e) {
        this.props.item.pmetadata = {}
      }
    }
    if (!this.props.item.pmetadata.public) this.props.item.pmetadata.public = {}

    if (isAutomatic === 'Undo') {
      this.props.item.sponsor = null
      this.props.item.sponsorId = 0
      this.props.item.assetSetId = 0
      delete this.props.item.resolvedSponsorId
      delete this.props.item.resolvedBrandId
      delete this.props.item.resolvedAssetSetId

      this.props.item.pmetadata.isManualOverride = false
      this.props.item.pmetadata.isAutomatic = true
      delete this.props.item.pmetadata.resolvedSponsorId
      delete this.props.item.pmetadata.resolvedBrandId
      delete this.props.item.pmetadata.resolvedAssetSetId
      delete this.props.item.pmetadata.placement_subbrand_text

      this.props.item.pmetadata.public.isManualOverride = false
      this.props.item.pmetadata.public.isAutomatic = true
      delete this.props.item.pmetadata.public.resolvedSponsorId
      delete this.props.item.pmetadata.public.resolvedBrandId
      delete this.props.item.pmetadata.public.resolvedAssetSetId
      delete this.props.item.pmetadata.public.placement_subbrand_text

      this.setState({
        announcementHasChanges: true,
      })
    } else {
      this.props.item.pmetadata.isManualOverride = true
      this.props.item.pmetadata.isAutomatic = false
      this.props.item.pmetadata.public.isManualOverride = true
      this.props.item.pmetadata.public.isAutomatic = false
    }

    if (val && val.sponsorItem) {
      const oldBrandId =
        this.props.item.sponsor && this.props.item.sponsor.sponsorItem
          ? this.props.item.sponsor.sponsorItem.brandId
          : this.props.item.sponsorId
      const oldAssetSetId =
        this.props.item.sponsor && this.props.item.sponsor.sponsorItem
          ? this.props.item.sponsor.sponsorItem.assetSetId
          : this.props.item.assetSetId

      if (
        oldBrandId !== val.sponsorItem.brandId ||
        oldAssetSetId !== val.sponsorItem.assetSetId
      ) {
        this.setState({
          announcementHasChanges: true,
        })
      } else {
        this.setState({
          announcementHasChanges: false,
        })
      }
    } else if (this.props.item.sponsorId !== 0 && isAutomatic === 'Default') {
      this.setState({
        announcementHasChanges: true,
      })
    }
    this.props.item.sponsor = val
    this.props.item.sponsorExpanded = false
    if (!val) {
      this.sponsorEnable(0, false)
    }
    const previewItem = Object.assign({}, this.props.item)
    this.props.GameStore.setAnnouncementValueObservable(previewItem)

    this.forceUpdate()

    if (isAutomatic === 'Undo') {
      if (this.handleUpdateChanges) {
        setTimeout(() => {
          this.handleUpdateChanges(true)
        }, 0)
      }
    }
  }

  sponsorEnable(val, isExpanded) {
    if (val === 1) {
      const bottomSponsor = document.getElementsByClassName(
        `${this.reference}-sponsor`
      )
      if (bottomSponsor) {
        this.props.item.sponsorExpanded = isExpanded
      }
    }
  }

  getType(type) {
    type = type.toLowerCase()
    return type === 'liveplay'
      ? 'live'
      : type === 'gamemaster'
      ? 'game'
      : type === 'sponsor'
      ? 'spon'
      : type === 'prize'
      ? 'priz'
      : type
  }

  isLModeActive() {
    return (
      this.props.selectionMode &&
      this.props.selectionMode.isSMode &&
      this.props.selectionMode.sModePlays &&
      this.props.selectionMode.sModePlays.length > 0 &&
      this.props.selectionMode.isLMode
    )
  }

  isPlayDisabledInLMode(item) {
    return (
      this.props.selectionMode &&
      this.props.selectionMode.isSMode &&
      this.props.selectionMode.isLMode &&
      (this.props.selectionMode.sModePlays || []).findIndex(
        sPlay => sPlay.gamePlayId === item.gamePlayId
      ) !== -1
    )
  }

  handlePlayCheckSMOde(item) {
    this.props.handlePlayCheckSMode(item)
  }

  handlePlayCheckLMode(item, index) {
    this.props.handleDestinationSelection(item)
  }

  render() {
    let {
      item,
      index,
      GameStore,
      zIndexIndex,
      isChecked,
      isDestination,
    } = this.props
    if (!item) return null
    let {
      sessionStarted,
      announcementHasChanges,
      isOpinionQuestion,
    } = this.state
    let bg = PlayColors[this.props.item.type.toLowerCase()]
    const editorReadOnly3Announce = `editor-readonly-3-Announce-${this.props.AutomationStore.playSequence}`
    return (
      <Draggable draggableId={item.index} index={index}>
        {(provided, snapshot) => (
          <Container
            innerRef={provided.innerRef}
            {...provided.draggableProps}
            zIndex={1000 - zIndexIndex}
          >
            <Main isDragging={snapshot.isDragging}>
              {this.props.selectionMode && this.props.selectionMode.isSMode ? (
                this.isLModeActive() ? (
                  <SelectionCheckWrapper>
                    <PlayCheckBox
                      widthInPct="5"
                      isDisabled={this.isPlayDisabledInLMode(item)}
                    >
                      <input
                        id={`l_mode_${item.gamePlayId}`}
                        type="checkbox"
                        checked={isDestination}
                        ref={ref =>
                          (this[`play-checkboxLMode${item.gamePlayId}`] = ref)
                        }
                        onChange={this.handlePlayCheckLMode.bind(this, item)}
                      />
                    </PlayCheckBox>
                  </SelectionCheckWrapper>
                ) : (
                  <SelectionCheckWrapper>
                    <PlayCheckBox widthInPct="6">
                      <input
                        id={`s_mode_${item.gamePlayId}`}
                        type="checkbox"
                        checked={isChecked}
                        ref={ref =>
                          (this[`play-checkboxSMode${item.gamePlayId}`] = ref)
                        }
                        onChange={this.handlePlayCheckSMOde.bind(this, item)}
                        style={{
                          width: responsiveDimension(1.7),
                          height: responsiveDimension(1.7),
                          position: 'absolute',
                        }}
                      />
                    </PlayCheckBox>
                  </SelectionCheckWrapper>
                )
              ) : null}
              <PlayStatusWrapper
                style={{
                  display:
                    this.props.selectionMode && this.props.selectionMode.isSMode
                      ? 'none'
                      : 'flex',
                }}
                {...provided.dragHandleProps}
              />
              <PlayTypeDD>
                <PrePlaySequence
                  backgroundColor={bg}
                  text={`${item.sequence}`}
                />
                <PrePlaySingle backgroundColor={bg}>
                  <span>{`${this.getType(item.type)}`}</span>
                  {isOpinionQuestion && (
                    <TextButton
                      name="opn"
                      color={'#000'}
                      backgroundColor={'#EFDF18'}
                      width={1.7}
                      height={1.2}
                    >
                      {'OPN'}
                    </TextButton>
                  )}
                </PrePlaySingle>
              </PlayTypeDD>
              <SelectTypeLocked
                title={this.MAIN_CHOICE && this.MAIN_CHOICE.preset}
              >
                {this.MAIN_CHOICE && this.MAIN_CHOICE.preset}
              </SelectTypeLocked>
              {/* <DDSelectType
                //disabled
                locked
                id={`dd-option-playitemonstack-${item.index}`}
                onChange={this.handleDDOptionChange.bind(this)}
                value={this.preItem.id}
              >
                {this.presetItems.map((pItem, i) => {
                  return (
                    <option key={i} value={pItem.id}>
                      {pItem.preset}
                    </option>
                  )
                })}
              </DDSelectType> */}
              <QuestionInput
                id={this.questionInputId}
                type="text"
                value={
                  this.props.liveEditingItem
                    ? this.playTitle || item.playTitle.value
                    : item.playTitle.value
                }
                onChange={this.handleQuestionChange.bind(
                  this,
                  this.questionInputId
                )}
              />
              <OptionInputsWrapper style={{ width: '25%' }}>
                {this.OptionInputs()}
              </OptionInputsWrapper>
              <StarWrapper>
                <DDStar
                  from="PlayItemOnStack"
                  // commented below line to allow operator to change the star
                  // locked={GameStore.isLockedForAllExecutionType}
                  item={item}
                  height={h}
                  index={'playitemonstack-' + item.index}
                  value={this.handleStarValue.bind(this)}
                  automationAddEvent={this.handleAutomationAddEvent.bind(this)}
                />
              </StarWrapper>
              {/* <SponsorBrandWrapper>
                <DDSponsorBrand
                  locked={GameStore.isLockedForAllExecutionType}
                  item={item}
                  height={h}
                  index={'playitemonstack-' + item.index}
                  selectedSponsor={item.sponsor}
                  value={this.handleSponsorBrandValue.bind(this)}
                  automationAddEvent={this.handleAutomationAddEvent.bind(this)}
                />
              </SponsorBrandWrapper> */}
              <AwardWrapper style={{ width: '15%' }}>
                <DDAwards
                  from="PlayItemOnStack"
                  locked={GameStore.isLockedForAllExecutionType}
                  item={JSON.parse(JSON.stringify(item))}
                  height={h}
                  index={'playitemonstack-' + item.index}
                  initValue={val => (item.award = val)}
                  value={this.handleAwardValue.bind(this)}
                  handleTimerChange={this.handleTimerChange.bind(this)}
                />
              </AwardWrapper>
              <DDSponsorWrapper
                className={`${this.reference}-sponsor`}
                style={{
                  display: 'block',
                  marginLeft: '0.2vh',
                }}
              >
                <DDAnnounceSponsor
                  height={h}
                  index={`${this.reference}-sponsor`}
                  selectedSponsor={null}
                  value={this.handleSelectedSponsor.bind(this)}
                  expanded={item.sponsorExpanded}
                  forId={editorReadOnly3Announce}
                  PlayStoreSample={this.props.PrePlayStore}
                  sponsorId={item.sponsorId}
                  playStackItem={true}
                  fromStack="PLAY_ITEM"
                  type={item ? item.type : ''}
                  subType={item ? item.subType : null}
                  sponsorMetaData={
                    item.sponsor ? item.sponsor.sponsorItem || null : null
                  }
                  pmetadata={
                    item.pmetadata
                      ? item.pmetadata.public || item.pmetadata
                      : null
                  }
                />
              </DDSponsorWrapper>
              {/* <PlayOrTimerWrapper>
                <PlayMode src={LockIcon} />
              </PlayOrTimerWrapper> */}
              {/*TO BE DELETED
              <PlayOrTimerWrapper>
                {'LIVEPLAY' === item.type.toUpperCase() ? (
                  <PlayMode src={LockIcon} />
                ) : (
                  <DDTimerMode
                    value={item.length}
                    onChange={this.handleDDTimerModeChange.bind(this)}
                  >
                    <option value={0}>PLAY</option>
                    <option value={10}>10 s</option>
                    <option value={15}>15 s</option>
                  </DDTimerMode>
                )}
              </PlayOrTimerWrapper>
*/}
              {/* <TeamWrapper>
                <DDTeam
                  //for future use: presetToNone={item.isPresetTeamChoice}
                  //for future use: locked={item.isPresetTeamChoice}
                  locked={GameStore.isLockedForAllExecutionType}
                  item={item}
                  height={h}
                  index={'playitemonstack-' + item.index}
                  teams={this.props.PrePlayStore.teams}
                  value={this.handleTeamValue.bind(this)}
                  headerSelectedTeam={this.props.headerSelectedTeam}
                  changeFromHeader={true}
                  automationAddEvent={this.handleAutomationAddEvent.bind(this)}
                />
              </TeamWrapper> */}
              <LastButtonWrapper>
                {this.promptRemove ? (
                  <PromptRemoveButton
                    // locked={GameStore.isLockedForAllExecutionType}
                    id={`final-remove-${item.type}-${item.id}`}
                    onClick={this.handlePromptRemoveClick.bind(
                      this,
                      `final-remove-${item.type}-${item.id}`
                    )}
                  />
                ) : (
                  <RemoveButton
                    id={`prompt-remove-${item.type}-${item.id}`}
                    onClick={this.handleRemoveClick.bind(
                      this,
                      `prompt-remove-${item.type}-${item.id}`
                    )}
                  />
                )}
                <GoButton
                  id={`go-button-${item.type}-${item.id}`}
                  locked={!sessionStarted}
                  onClick={
                    !sessionStarted
                      ? null
                      : this.handleGoClick.bind(
                          this,
                          item.id,
                          `go-button-${item.type}-${item.id}`
                        )
                  }
                  innerRef={ref => (this[`stack-play-go-${item.id}`] = ref)}
                />
                <PendingIndicator
                  src={PendingIndicatorIcon}
                  innerRef={ref =>
                    (this[`stack-play-indicator-go-${item.id}`] = ref)
                  }
                />
                {this.hasChanges || announcementHasChanges ? (
                  <UpdateChangesButton
                    onClick={this.handleUpdateChanges.bind(this)}
                  />
                ) : null}
              </LastButtonWrapper>
            </Main>

            <Sub id={`sub-container-${item.index}`} />
          </Container>
        )}
      </Draggable>
    )
  }
}

const h = 6
let FONT_SIZE = '1.8vh'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  opacity: 0;
  animation: ${props => fadeIn} 0.3s forwards;
  height: auto;
  margin-top: ${props => 0.1}vh;
  margin-bottom: ${props => 0.1}vh;
  position: relative;
  z-index: ${props => props.zIndex};
`
const fadeIn = keyframes`
  0%{opacity: 0;}
  100%{opacity: 1}
`

const Main = styled.div`
  width: inherit;
  height: ${props => h}vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  -webkit-filter: grayscale(${props => (props.isDragging ? 1 : 0)});
`

const Sub = styled.div`
  width: 90%;
  background: yellow;
`

const PrePlaySequence = styled.div`
  width: 40%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainlight;
  font-size: ${props => FONT_SIZE};
  color: white;
  line-height: 1;
  border-right: 0.5px solid;
  &:after {
    content: '${props => props.text}';
  }
`

const PrePlaySingle = styled.div`
  width: 60%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: white;
  text-transform: uppercase;
`

const TextButton = styled.div`
  position: absolute;
  left: 10%;
  top: 38%;
  padding-top: 0.1%;
  width: ${props => responsiveDimension(props.width || 2)};
  height: ${props => responsiveDimension(props.height || 2)};
  color: ${props => props.color || '#fff'};
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainregular;
  font-size: ${props => responsiveDimension(0.7)};
  border: ${responsiveDimension(0.2)} solid #000;
  opacity: ${props => (props.isDisabled ? 0 : '')};
  pointer-events: ${props => (props.isDisabled ? 'none' : '')};
`

const PlayTypeDD = styled.div`
  width: 8.3%;
  height: ${props => h}vh;
  display: flex;
`
const SelectTypeLocked = styled.div`
  width: 7%;
  height: ${props => h}vh;
  background-color: #e5e5e5;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: #000000;
  text-transform: uppercase;
  display: block;
  text-align: center;
  line-height: ${props => h}vh;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.5vh;
`

const PlayCheckBox = styled.div`
  width: ${props => props.widthInPct}%;
  height: ${props => 6}vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.backgroundColor || '#ffffff'};
  opacity: ${props => (props.isDisabled ? 0.2 : 1)};
  pointer-events: ${props => (props.isDisabled ? 'none' : '')};
`

const SelectionCheckWrapper = styled.div`
  width: 3%;
  height: ${props => h}vh;
  background-color: #a7a9ac;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const PlayStatusWrapper = styled.div`
  width: 3%;
  height: ${props => h}vh;
  background-color: #a7a9ac;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url(${DragNDropIcon});
  background-repeat: no-repeat;
  background-size: 80%;
  background-position: center;
`

const QuestionInput = styled.input`
  width: 21%;
  height: inherit;
  border: ${props => 0.05}vh;
  outline: none;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  text-transform: uppercase;
  text-indent: ${props => 1}vh;
  background-color: white;
`

const OptionInputDiv = styled.div`
  width: 100%;
  height: inherit;
  ${props => (props.marginRight ? `margin-right:${2}px` : ``)};
`

const OptionInput = styled.input`
  width: 100%;
  height: inherit;
  background-color: ${props => props.backgroundColor};
  text-align: center;
  border: none;
  outline: none;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  text-transform: uppercase;
  color: ${props => props.color};
`

const SponsorBrandWrapper = styled.div`
  width: 10%;
  height: ${props => h}vh;
  position: relative;
`

const TeamWrapper = styled.div`
  width: 8%;
  height: inherit;
  border-left: ${props => 0.1}vh solid black;
  position: relative;
`

const TeamItemWrapper = styled.div`
  width: 100%;
  height: inherit;
  ${props => (props.marginRight ? `margin-right:${2}px` : ``)};
`

const PlayMode = styled.div`
  width: 100%;
  height: inherit;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  &:before {
    content: 'PLAY';
    margin-left: ${props => 2}vh;
  }
  &:after {
    width: inherit;
    height: inherit;
    content: '';
    display: inline-block;
    background-image: url(${props => props.src});
    background-repeat: no-repeat;
    background-size: 45%;
    background-position: center;
  }
`

const DDTimerMode = styled.select`
  width: inherit;
  height: inherit;
  outline: none;
  border: none;
  -webkit-appearance: none;

  background-image: url(${UpArrowIcon});
  background-repeat: no-repeat;
  background-position: bottom ${props => -0.5}vh right;
  background-size: ${props => 2}vh;
  font-family: pamainbold;
  color: #000000;
  line-height: 1;
  text-align-last: center;
  font-weight: bold;
`

const RemoveButton = styled.div`
  width: 75%;
  height: inherit;
  background-color: #18c5ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  -webkit-filter: grayscale(1);
  opacity: 0.3;
  &:after {
    content: 'REMOVE';
    color: black;
  }
`

const PromptRemoveButton = styled.div`
  width: 75%;
  height: inherit;
  background-color: #18c5ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  &:after {
    content: 'REMOVE PLAY?';
    color: black;
  }
`

const GoButton = styled.div`
  width: 25%;
  height: ${props => h}vh;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  -webkit-filter: ${props => (props.locked ? 'grayscale(1)' : 'grayscale(0)')};
  opacity: ${props => (props.locked ? 0.4 : 1)};
  position: relative;
  &:after {
    content: 'GO';
    color: #18c5ff;
  }
`

const PendingIndicator = styled.div`
  width: 10%;
  height: ${props => h}vh;
  background-color: #000000;
  display: none;
  align-items: center;
  &:after {
    content: '';
    display: block;
    width: ${props => h}vh;
    height: ${props => h}vh;
    background-image: url(${props => props.src});
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    animation: ${props => pendingRotate} 5s linear infinite;
    transform-origin: center center;
  }
`

const pendingRotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const LastButtonWrapper = styled.div`
  width: 9.5%;
  display: flex;
  justify-content: space-between;
  position: relative; /*added for UpdateButton*/
`

const UpdateChangesButton = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #ff0000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:after {
    content: 'update changes';
    font-family: pamainbold;
    font-size: ${props => FONT_SIZE};
    color: #ffffff;
    line-height: 1;
    text-transform: uppercase;
  }
`

const DDSponsorWrapper = styled.div`
  width: 10%;
  position: relative;
  display: none;
  background-repeat: no-repeat;
  background-position: bottom -0.4vh right;
  background-size: 1.4vh;
  background-image: url(/static/media/preplay-up-arrow-black.86e9a30f.svg);
`



// WEBPACK FOOTER //
// src/Components/CommandHost/PlayItemOnStack.js